import { render, staticRenderFns } from "./order_return_edit.vue?vue&type=template&id=1b6fd7f0&scoped=true"
import script from "./order_return_edit.vue?vue&type=script&lang=js"
export * from "./order_return_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6fd7f0",
  null
  
)

export default component.exports